import { use_media_query_default } from "./chunk-CNNESRES.js";

// src/hooks/use-breakpoint.ts
import { useMemo } from "react";
import breakpointTokens from "@printdeal/brand/common/tokens/breakpoints.cjs";
var toMaxBreakpointValue = breakpointValue => "".concat(parseInt(breakpointValue.split("px")[0], 10) - 0.02, "px");
var useBreakpoint = breakpointQuery => {
  const query = useMemo(() => {
    if (breakpointQuery.includes(":") && breakpointQuery.includes("max-")) {
      const minBreakpoint = breakpointQuery.split(":")[0];
      const maxBreakpoint = breakpointQuery.split("max-")[1];
      return "(min-width: ".concat(breakpointTokens[minBreakpoint].value, ") and (max-width: ").concat(toMaxBreakpointValue(breakpointTokens[maxBreakpoint].value), ")");
    }
    if (breakpointQuery.includes("max-")) {
      const maxBreakpoint = breakpointQuery.split("max-")[1];
      return "(max-width: ".concat(toMaxBreakpointValue(breakpointTokens[maxBreakpoint].value), ")");
    }
    return "(min-width: ".concat(breakpointTokens[breakpointQuery].value, ")");
  }, [breakpointQuery]);
  return use_media_query_default(query);
};
var use_breakpoint_default = useBreakpoint;
export { use_breakpoint_default };